import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Modal, Button } from '@bingads-webui-react/primitive';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getStyles } from '../styles/identity-verification-dialog';
import { getDefaultModalStyle } from '../styles/common-styles';

export const LegalBusinessNameMismatch = ({
  i18n,
  isShow,
  legalBusinessName,
  individualFullName,
  onDialogClose,
  onUpdateAbl,
  onReviewIndividualInfo,
  updateAblButtonDisabled,
}) => {
  const classes = useDefaultStyles(getStyles);
  const defaultStyleClasses = useDefaultStyles(getDefaultModalStyle);

  return (
    <Modal
      id="identityVerificationLegalBusinessNameMismatchDialog"
      show={isShow}
      backdrop="static"
      className="identity-verification-legal-business-name-mistmatch-dialog"
      onHide={onDialogClose}
      dialogClassName={defaultStyleClasses.modalWidth}
    >
      <Modal.Header className="legal-business-name-mistmatch-header" closeButton>
        <Modal.Title>{i18n.getString(_TL_('Legal business name mismatch'))}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classNames('legal-business-name-mistmatch-content', classes.content)}>
        <React.Fragment>
          <p>
            <ReactTemplate
              model={{
                legalBusinessName: <span className="bold">{legalBusinessName}</span>,
                individualFullName: <span className="bold">{individualFullName}</span>,
              }}
              template={i18n.getString(_TL_("For individual verification, the account's legal business name ({{legalBusinessName}}) must match your full name ({{individualFullName}})."))}
            />
          </p>
          {updateAblButtonDisabled ?
          <p>{i18n.getString(_TL_('If you want to verify as a business instead you can go back and start over.'))}</p> :
          <p>{i18n.getString(_TL_('Update your business name or full name to continue with individual verification. If you want to verify as a business instead you can go back and start over.'))}</p>}
        </React.Fragment>
      </Modal.Body>
      <Modal.Footer className="legal-business-name-mistmatch-footer">
        <Button className="update-business-name-button" btnStyle="primary" onClick={onUpdateAbl} disabled={updateAblButtonDisabled}>{i18n.getString(_TL_('Update my business name'))}</Button>
        <Button className="review-individual-info-button" onClick={onReviewIndividualInfo} >{i18n.getString(_TL_('Got it'))}</Button>
      </Modal.Footer>
    </Modal>
  );
};

LegalBusinessNameMismatch.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isShow: PropTypes.bool.isRequired,
  legalBusinessName: PropTypes.string.isRequired,
  individualFullName: PropTypes.string.isRequired,
  onDialogClose: PropTypes.func.isRequired,
  onUpdateAbl: PropTypes.func.isRequired,
  onReviewIndividualInfo: PropTypes.func.isRequired,
  updateAblButtonDisabled: PropTypes.bool,
};
LegalBusinessNameMismatch.defaultProps = {
  updateAblButtonDisabled: false,
};
